module.exports = __webpack_public_path__ + "img/unholy.3c1be443.jpg";